import { PageHeader } from '../../components/ui/PageHeader.tsx';
import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router';
import { api } from '../../lib/api.ts';
import { useClientGrid } from '../../lib/grid.ts';
import { VSTATUS, type Clause, type VersionDetail } from '../../lib/policy/api.ts';
import { PolicyEditor } from './PolicyEditor.tsx';
import { DataTable, type Column } from '../../components/DataTable.tsx';
import { buttonClass } from '../../components/ui/Button.tsx';

const CLAUSE_COLS: Column<Clause>[] = [
  { key: 'path', label: '경로', width: '120px', filter: 'text', render: (c) => <span className="font-mono">{c.path}</span> },
  { key: 'noLabel', label: '번호', width: '80px', filter: 'none' },
  { key: 'heading', label: '제목', width: '220px', filter: 'text' },
  { key: 'text', label: '본문', wrap: true, filter: 'text', render: (c) => <div className="truncate" title={c.text}>{c.text}</div> },
  { key: 'controlIds', label: '통제항목', width: '80px', align: 'right', filter: 'none', filterValue: (c) => c.controlIds.length, render: (c) => c.controlIds.length || '' },
];

/** 버전 읽기 전용 보기 */
export function PolicyVersionPage() {
  const { id = '' } = useParams();
  const q = useQuery({ queryKey: ['policy-version', id], queryFn: () => api<VersionDetail>(`/policies/versions/${id}`) });
  const clauseGrid = useClientGrid(q.data?.clauses, CLAUSE_COLS, { pageSize: 50 });
  if (!q.data) return <div>{q.isError ? (q.error as Error).message : '불러오는 중…'}</div>;
  const v = q.data;
  return (
    <div className="">
      <PageHeader back={{ to: `/policies/${v.documentId}`, label: `${v.document.title}` }} title={<>{v.document.title} — {v.versionNo ? `v${v.versionNo}` : '초안'} <span className="text-sm font-normal text-slate-500">{VSTATUS[v.status]}{v.effectiveDate && ` · 시행 ${v.effectiveDate.slice(0, 10)}`}</span></>} />
      {v.changeSummary && <div className="text-sm text-slate-600 mb-3">개정 사유: {v.changeSummary}</div>}
      {v.canEdit && <Link className={'inline-block mb-3 ' + buttonClass('primary')} to={`/policies/versions/${v.id}/edit`}>편집</Link>}
      <PolicyEditor initial={v.body} onChange={() => {}} editable={false} />
      <details className="mt-4 text-sm"><summary className="cursor-pointer text-slate-600">조항 목록 ({v.clauses.length})</summary>
        <div className="mt-2"><DataTable id="policy-version" columns={CLAUSE_COLS} data={clauseGrid.data} state={clauseGrid.state} onChange={clauseGrid.set} size="sm" pagination="auto" rowKey={(c) => c.path} emptyText="조항 없음" /></div>
      </details>
    </div>
  );
}
